module.exports = __webpack_public_path__ + "img/pet-breeds.f53df745.svg";